import axios from 'axios';
import { phoneMask } from "../utils/masks";

const phoneInput = document.getElementById("phone");
phoneMask(phoneInput);

const cep = document.getElementById('postal_code')

async function cepRequest() {
  try {
    const response = await axios.get(`https://brasilapi.com.br/api/cep/v1/${cep.value}`)
    document.getElementById('address').value = response.data.street
    document.getElementById('city').value = response.data.city
    document.getElementById('uf').value = response.data.state
    document.getElementById('neighborhood').value = response.data.neighborhood
  } catch (error) {
    console.error(error)
  }
}

window.onload = function () {
  cep.addEventListener("blur", cepRequest)
}